module.exports = __webpack_public_path__ + "img/avatar.20da32cc.jpg";